import React from 'react'
import Menu from 'react-burger-menu/lib/menus/slide'

export const BurgerMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleLinkClick = () => {
    // リンクがクリックされたときの処理
    setIsOpen(false)
  }

  const handleMenuStateChange = (state) => {
    // メニューの状態が変更されたときの処理
    setIsOpen(state.isOpen)
  }

  return (
    <Menu isOpen={isOpen} onStateChange={handleMenuStateChange} right>
      <div id='page-wrap'>
        <div id='menu-wrap'>
          <a href='/fashion'>toeL Fashion</a>
          <a href='#feature' onClick={handleLinkClick}>
            FEATURE
          </a>
          <a href='#lineup' onClick={handleLinkClick}>
            LINE UP
          </a>
          <a href='#interview' onClick={handleLinkClick}>
            INTERVIEW
          </a>
        </div>
      </div>
    </Menu>
  )
}

export default BurgerMenu
